import {Box, Grid} from '@primer/react-brand/esm'
import baseStyles from '../../styles/base.module.css'
import type {CustomerStory} from '../../types'
import {LogoStoryCard} from './LogoStoryCard'

export function getLogoCardLargeColumnSpan(storyCount: number): 4 | 6 {
  return storyCount > 2 ? 4 : 6
}

export function LogoCards({stories}: {stories: CustomerStory[]}) {
  const columnSpan = getLogoCardLargeColumnSpan(stories.length)

  return (
    <Box className={baseStyles.gridFrameBottom}>
      <Grid columnGap="none" rowGap="none" enableGutters={false}>
        <Grid.Column span={{xsmall: 12, medium: 10, xlarge: 12}} start={{medium: 2}}>
          <Grid columnGap="none" rowGap="none" enableGutters={false} className={baseStyles.narrowStackFrame}>
            {stories.map(story => (
              <Grid.Column
                key={story.sys.id}
                span={{xsmall: 12, xlarge: columnSpan}}
                // eslint-disable-next-line @github-ui/github-monorepo/no-global-classname-literals
                className="gridColumn"
              >
                <LogoStoryCard story={story} />
              </Grid.Column>
            ))}
          </Grid>
        </Grid.Column>
      </Grid>
    </Box>
  )
}
